import { Grid, Typography } from "@mui/material";
import React from "react";
import { useActividadesContext } from "../../Hook/useActividades";
import MarkDownEditor from "../../../MarkDownText/MarkDownEditor";
import MarkDownText from "../../../MarkDownText/MarkDownText";

export const BodyUmmiaAppsResult = () => {
  const {
    editMode,
    respuestaEditable,
    setRespuestaEditable,
    respuestaAPI,
    textoInicial,
    respuestaImg
  } = useActividadesContext();
  return (
    <Grid item xs={12} sx={{ width: "100%"}}>
      {editMode ? (
        <Grid>
          <MarkDownEditor
            data={respuestaEditable}
            setEditedValue={setRespuestaEditable}
            img={respuestaImg}
          />
        </Grid>
      ) : (
        <>
          <Grid
            sx={{ padding: 2, borderRadius: 3, border: "2px solid #336B87" }}
          >
            <Typography variant="body1" fontFamily={"montserrat"}>
              {textoInicial ??
                `Esta es la propuesta que tengo para ti. 
                                    Puedes revisar y editar cualquier parte según tus necesidades. 
                                    Puedes volver a "Mostrar campos" para ajustar los parámetros que desees, 
                                    pedirle a UmmIA "Volver a generar" la propuesta o "Copiar" el texto para poder trabajarlo en otra aplicación.`}
            </Typography>
          </Grid>
          <MarkDownText data={respuestaAPI} img={respuestaImg}/>
        </>
      )}
    </Grid>
  );
};
